import React, { useEffect, useState } from 'react'
import './SignUpScreenNotHome.css'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { auth, db, functions } from '../../firebase.js'
import { neo4jcreateUserNode } from '../../services/neo4j.js';
import { httpsCallable } from 'firebase/functions';
import { checkIfUsernameExists, getCurrentUserData, getUserInfoWithId, getUserInfoWithUsername } from '../../services/f.js';
import { Oval } from 'react-loader-spinner'
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

function SignUpScreenNotHome({ setchangedlogin }) {
    const [email, setemail] = useState("");
    const [username, setusername] = useState("");
    const [pw, setpw] = useState("");
    const [acceptedtos, setacceptedtos] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    const [usernametaken, setusernametaken] = useState(false);
    const [errorsignup, seterrorsignup] = useState(false);
    const [sthempty, setsthempty] = useState(false);
    const [errorlogin, seterrorlogin] = useState(false);

    const [referralname, setreferralname] = useState("");
    const [referralid, setreferralid] = useState(null);

    const [logintype, setlogintype] = useState(false);

    const [showanimation, setshowanimation] = useState(false);

    const [novalidemail, setnovalidemail] = useState();

    const [signedupfornewsletter, setsignedupfornewsletter] = useState(false);
    const [newslettererror, setnewslettererror] = useState(false);

    const dispatch = useDispatch()

    useEffect(() => {
        // console.log("referralname", referralname)
        if (referralname === null || referralname === undefined) {

        } else {
            getUserInfoWithUsername(referralname).then((referraldoc) => (setreferralid(referraldoc)))
        }
    }, [referralname]);

    useEffect(() => {
        // homelink so /
        let referral = searchParams.get("referral")
        if (referral === null) {

        } else {
            setreferralname(referral)
        }

    }, []);

    const register = (e) => {
        //console.log("register")
        e.preventDefault();
        setshowanimation(true)
        seterrorlogin(false)
        if (email === "" || username === "" || pw === "") {
            setsthempty(true)
            setshowanimation(false)
            return
        } else {
            setsthempty(false)
        }

        checkIfUsernameExists(username.toLowerCase()).then((res) => {
            // console.log("checkIfUsernameExists")
            if (res.length !== 0) {
                setusernametaken(true)
                setshowanimation(false)
                return
            } else {
                createUserWithEmailAndPassword(auth, email, pw)
                    .then((userCredential) => {
                        // Signed in 
                        const user = userCredential.user;
                        //console.log("this is userid", user.uid)
                        const createWholeUser = httpsCallable(functions, 'createWholeUser');
                        createWholeUser({ user: user.uid, username: username.toLowerCase(), email: email, referralid: referralid === null ? "" : referralid[0], referralname: referralname })
                            .then((result) => {
                                // Read result of the Cloud Function.
                                //console.log("resulttt createWholeUser", result)
                                if (result.data === "success") {
                                    //console.log("worked ot register")
                                    dispatch(getCurrentUserData())
                                    setchangedlogin(true)

                                    neo4jcreateUserNode(username).then(() => {

                                        //create cloud func to create these both bc creating not allowed
                                        const createSubcollectionForUser = httpsCallable(functions, 'createSubcollectionForUser');
                                        createSubcollectionForUser({ user: user.uid })
                                            .then((result) => {
                                                // Read result of the Cloud Function.
                                                //console.log("resulttt createSubcollectionForUser", result)
                                                if (result.data === "success") {
                                                    //console.log("worked ot register")
                                                    setshowanimation(false)
                                                    seterrorsignup(false)
                                                } else {
                                                    seterrorsignup(true)
                                                    setshowanimation(false)
                                                }
                                            })
                                            .catch((error) => {
                                                // Getting the Error details.
                                                const code = error.code;
                                                const message = error.message;
                                                const details = error.details;
                                                //console.log("errorcloudfunction", error)
                                                seterrorsignup(true)
                                                setshowanimation(false)
                                            });
                                    })

                                } else {
                                    seterrorsignup(true)
                                    setshowanimation(false)
                                }
                            })
                            .catch((error) => {
                                // Getting the Error details.
                                const code = error.code;
                                const message = error.message;
                                const details = error.details;
                                //console.log("errorcloudfunctionone", error)
                                seterrorsignup(true)
                                setshowanimation(false)

                            });
                    })
                    .catch((error) => {

                        //console.log(error)
                        // ..
                        // console.log("didnt work to register inner", error.code, error.message, error.details)
                        seterrorsignup(true)
                        setshowanimation(false)
                    });
            }
        }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            //console.log(error)
            // ..
            //console.log("didnt work to register", error)
            seterrorsignup(true)
            setshowanimation(false)

        });
    }

    const signIn = (e) => {
        seterrorsignup(false)
        setshowanimation(true)
        //console.log("sign in now", email, pw)
        e.preventDefault();

        if (email === "" || pw === "") {
            setsthempty(true)
            setshowanimation(false)
            return
        } else {
            setsthempty(false)
        }

        signInWithEmailAndPassword(
            auth,
            email,
            pw,
        ).then((authuser) => {
            //console.log("logged in", authuser)
            setshowanimation(false)
            seterrorlogin(false)
            dispatch(getCurrentUserData())
            setchangedlogin(true)
        }).catch((error) => {
            //console.log("err loggingi in", error)
            seterrorlogin(true)
            setshowanimation(false)
        })
    }

    const isValidEmail = (emailtotext) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(emailtotext);
    };

    const getNotified = (e) => {
        seterrorsignup(false)
        setshowanimation(true)
        // console.log("sign in now")
        e.preventDefault();

        console.log("getnotifed function", email)

        if (email === "") {
            setsthempty(true)
            setshowanimation(false)
            return
        } else {
            console.log("first", isValidEmail(email))
            if (isValidEmail(email) === false) {
                setnovalidemail(true)
                setshowanimation(false)

            } else {
                setnovalidemail(false)
                setsthempty(false)
                //continue to send email to sendgrid
                console.log("sending email to backend<")
                const sendemailfromnewslettertosendgrid = httpsCallable(functions, 'sendemailfromnewslettertosendgrid');
                sendemailfromnewslettertosendgrid({ email: email })
                    .then((result) => {
                        console.log("sendemailfromnewslettertosendgrid", result)
                        if (result.data === "success") {
                            //console.log("worked buying")
                            setshowanimation(false)
                            setsignedupfornewsletter(true)
                            //refresh user account or financials
                        } else {
                            //if response is error let user know with alert or so
                            setshowanimation(false)
                            setnewslettererror(true)
                        }
                    })
                    .catch((error) => {
                        setshowanimation(false)
                        setnewslettererror(true)
                    });
            }
        }

    }


    return (
        <div className="SignupScreenNotHome">
            <form>
                {/*
                {!logintype ?
                    <>
                        <h1 style={{ textAlign: "left" }}>Sign In</h1>
                        <p style={{ color: "black", textAlign: "center", marginBottom: 20 }}>Premsi is still invite-only to exclusive and supportive users. You can sign-up and become an early user over our App</p>

                        <input onChange={(e) => setemail(e.target.value)} type="email" placeholder='Email address' />
                        <input onChange={(e) => setpw(e.target.value)} type="password" placeholder='Password' />
                        {showanimation ?
                            <Oval
                                height={40}
                                width={40}
                                color="#009FFD"
                                wrapperStyle={{ flex: "display", alignItems: "center", justifyContent: "center" }}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="white"
                                strokeWidth={5}
                                strokeWidthSecondary={5}
                            />
                            :
                            <button style={{ borderRadius: 50 }} onClick={signIn} type="submit" >Sign In</button>}
                    </>
                    :
                    <>
                        <h1 style={{ textAlign: "center" }}>Invite <span className="font-body-inline">-</span> Only</h1>

                        <p style={{ color: "black", textAlign: "center", marginBottom: 10 }}>Premsi is still invite-only to exclusive and supportive users. Put in your invite code in our App!</p>

                        <p style={{ color: "black", textAlign: "center", marginBottom: 10 }}>Don't have one? Just follow and DM us on IG and X and we will give it to you, or invite 3 friends.</p>

                        <p style={{ color: "black", textAlign: "center", marginBottom: 20 }}>Or put in your email below to get notified when we let in more users.</p>

                        <input onChange={(e) => setemail(e.target.value)} type="email" placeholder='Email address' />
                        {showanimation ?
                            <Oval
                                height={40}
                                width={40}
                                color="#009FFD"
                                wrapperStyle={{ flex: "display", alignItems: "center", justifyContent: "center" }}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="white"
                                strokeWidth={5}
                                strokeWidthSecondary={5}
                            />
                            :
                            <div class="hero-cta">
                                {false && <button style={{ borderRadius: 50 }} onClick={getNotified} type="submit" >Get notified</button>}

                                <button onClick={() => getNotified()} type="submit" class="btn-hero btn-get-started">Get notified</button>
                            </div>}
                        {sthempty ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>Fill out your email.</p> : null}
                        {novalidemail ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>Your email has an issue.</p> : null}
                        {signedupfornewsletter && <p style={{ textAlign: "center", color: "green", fontSize: 12 }}>You're signed up. We will let you in soon.</p>}
                        {newslettererror && <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>There is an issue somewhere.</p>}
                    </>
                }

                <h5 style={{ textAlign: "center" }}>
                    <span style={{ color: "gray", marginRight: 5, textAlign: "center" }}>{logintype === false ? "New to Premsi?" : "Already have an account?"}</span>
                    <span className="SignupScreen__link" onClick={() => (setpw(""), setusername(""), setemail(""), setlogintype(!logintype))}>{logintype === false ? "Sign Up" : "Sign in"}</span>
                </h5>
                */}

                {/* uncomment below when start premsi for real */}

                {!logintype ?
                    <>
                        <input onChange={(e) => setemail(e.target.value)} type="email" placeholder='Email address' />
                        <input onChange={(e) => setpw(e.target.value)} type="password" placeholder='Password' />
                        {showanimation ?
                            <Oval
                                height={40}
                                width={40}
                                color="#009FFD"
                                wrapperStyle={{ flex: "display", alignItems: "center", justifyContent: "center" }}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="white"
                                strokeWidth={5}
                                strokeWidthSecondary={5}
                            />
                            :
                            <button onClick={signIn} type="submit" >Sign In</button>}
                    </>
                    :
                    <>
                        <input onChange={(e) => setusername(e.target.value)} type="text" placeholder='Username' />
                        <input onChange={(e) => setemail(e.target.value)} type="email" placeholder='Email address' />
                        <input onChange={(e) => setpw(e.target.value)} type="password" placeholder='Password' />
                        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "start" }}>
                            <input onChange={() => setacceptedtos(!acceptedtos)} type="checkbox" id="scales" name="scales" checked={acceptedtos} />
                            <label for="scales" style={{ marginLeft: 5, fontSize: 12 }}>Accept <a href="termsofservice" style={{ color: "black" }}>Terms of Service</a></label>
                        </div>
                        {showanimation
                            ?
                            <Oval
                                height={40}
                                width={40}
                                color="#009FFD"
                                wrapperStyle={{ flex: "display", alignItems: "center", justifyContent: "center" }}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="white"
                                strokeWidth={5}
                                strokeWidthSecondary={5}
                            />
                            :
                            (acceptedtos ? <button onClick={register} type="submit" >Create Account</button> : <div className="accepttosbutton" >Please accept TOS</div>)}
                        {searchParams.get("referral") === null
                            ?
                            null
                            :
                            (referralid === "empty"
                                ?
                                <h6 style={{ color: "gray" }}>Referral doesn't exist!</h6>
                                :
                                <h6 style={{ color: "gray" }}>Your referral: {referralname}</h6>)
                        }
                    </>
                }
                {usernametaken ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>Username taken! Choose another</p> : null}
                {errorsignup ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>There was an error signin up. Check valid e-mail.</p> : null}
                {sthempty ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>Fill out everything.</p> : null}
                {errorlogin ? <p style={{ textAlign: "center", color: "red", fontSize: 12 }}>There was an error loging in. Check password/email.</p> : null}

                <h5>
                    <span style={{ color: "gray", marginRight: 5, fontSize: 13, textAlign: "center" }}>{logintype === false ? "New to Premsi?" : "Already have an account?"}</span>
                    <span className="SignupScreen__link" style={{ fontSize: 13, textAlign: "center" }} onClick={() => (setpw(""), setusername(""), setemail(""), setlogintype(!logintype))}>{logintype === false ? "Sign Up now." : "Sign In."}</span>
                </h5>

                <div style={{ display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center", marginTop: 20 }}>
                    <img loading="lazy" src={require('../../images/creator.webp')} style={{ marginLeft: 0, height: 44, width: 150, borderRadius: 55 }} alt="Premsi.com logo app icon" />
                    <h5 style={{ color: "black", marginTop: 10 }}>Trusted by 2,000+ creators! | 2M$ paid out</h5>
                </div>

                <div style={{ display: "flex", marginTop: 20 }}>
                    <div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-around", marginBottom: 20, marginTop: 10 }}>
                        <a href="https://apps.apple.com/app/apple-store/id6446628909" style={{ cursor: "pointer", display: "flex", alignItems: "center", marginRight: 20 }} target='_blank'><img loading="lazy" src={require('../../images/appstore.webp')} style={{ cursor: "pointer", height: 45, borderRadius: 5 }} alt="Premsi.com App store link" /></a>
                        <a href="https://play.google.com/store/apps/details?id=com.Premsi.app" style={{ cursor: "pointer", display: "flex", alignItems: "center", marginLeft: 20 }} target='_blank'><img loading="lazy" src={require('../../images/googleplay.webp')} style={{ cursor: "pointer", height: 45, borderRadius: 5, borderColor: "black", borderWidth: 1, borderStyle: "solid" }} alt="Premsi.com Google play store link" /></a>
                    </div>
                </div>

            </form>
        </div>
    )
}

export default SignUpScreenNotHome
